<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 20 20"
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		role="img"
		:aria-hidden="ariaHidden"
	>
		<path
			d="M13.3333 8.95866C13.3333 9.40069 13.1577 9.82461 12.8452 10.1372C12.5326 10.4497 12.1087 10.6253 11.6667 10.6253H5.68999C5.248 10.6254 4.82414 10.8011 4.51166 11.1137L2.67666 12.9487C2.59391 13.0314 2.48849 13.0877 2.37373 13.1106C2.25897 13.1334 2.14002 13.1217 2.03191 13.0769C1.92381 13.0321 1.83141 12.9563 1.76639 12.859C1.70138 12.7617 1.66667 12.6473 1.66666 12.5303V3.95866C1.66666 3.51663 1.84225 3.09271 2.15481 2.78015C2.46737 2.46759 2.8913 2.29199 3.33332 2.29199H11.6667C12.1087 2.29199 12.5326 2.46759 12.8452 2.78015C13.1577 3.09271 13.3333 3.51663 13.3333 3.95866V8.95866Z"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M16.6667 8.125C17.1087 8.125 17.5326 8.3006 17.8452 8.61316C18.1577 8.92572 18.3333 9.34964 18.3333 9.79167V18.3633C18.3333 18.4803 18.2986 18.5947 18.2336 18.692C18.1686 18.7893 18.0762 18.8651 17.9681 18.9099C17.86 18.9547 17.741 18.9664 17.6262 18.9436C17.5115 18.9207 17.4061 18.8644 17.3233 18.7817L15.4883 16.9467C15.1758 16.6341 14.752 16.4584 14.31 16.4583H8.33332C7.8913 16.4583 7.46737 16.2827 7.15481 15.9702C6.84225 15.6576 6.66666 15.2337 6.66666 14.7917V13.9583"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconDialogue',
	props: {
		size: {
			type: [Number, String],
			default: 20
		},
		color: {
			type: String,
			default: 'currentColor'
		},
		filled: {
			type: Boolean,
			default: true
		},
		strokeWidth: {
			type: [Number, String],
			default: 1.65
		},
		ariaHidden: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		computedFill() {
			return this.filled ? this.color : 'none'
		},
		computedStroke() {
			return this.color
		}
	}
}
</script>
